import { cn } from "@/lib/cn";

interface ProChipProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "className"> {
  active?: boolean;
  /** `compact` — shorter chip for dense mobile rails (e.g. POS categories). */
  size?: "default" | "compact";
  className?: string;
}

function ProChip({
  active = false,
  size = "default",
  className,
  children,
  ...props
}: ProChipProps) {
  return (
    <button
      type="button"
      className={cn(
        "chip inline-flex shrink-0 items-center gap-1.5 rounded-full border border-pro-border bg-pro-elevated font-semibold text-pro-text-secondary transition-all duration-150 cursor-pointer",
        "hover:border-pro-text-faint hover:text-pro-text",
        size === "compact"
          ? "h-8 px-2.5 text-[11px]"
          : "h-[30px] max-md:min-h-11 max-md:h-auto px-3 text-[12px]",
        active && "active border-[rgba(198,244,50,0.3)] bg-lime-subtle text-lime",
        className,
      )}
      aria-pressed={active}
      {...props}
    >
      {children}
    </button>
  );
}

export { ProChip, type ProChipProps };
